import React from 'react'
import { Link } from 'react-router-dom'
import home_bg from '../../assets/estate1.jpg'
import estate2 from '../../assets/house2.png'

const Properties = () => {
	return (
		<main>
			<section
				className='section novi-background breadcrumbs-custom bg-image context-dark'
				style={{ backgroundImage: `url(${home_bg})` }}
			>
				<div className='breadcrumbs-custom-inner'>
					<div className='container breadcrumbs-custom-container'>
						<div className='breadcrumbs-custom-main'>
							<h6
								className='breadcrumbs-custom-subtitle title-decorated'
								style={{ color: 'transparent' }}
							>
								Properties
							</h6>
							<h2 className='text-uppercase breadcrumbs-custom-title'>
								Properties
							</h2>
						</div>
						<ul className='breadcrumbs-custom-path'>
							<li>
								<Link to='/'>Home</Link>
							</li>
							<li className='active'>Properties</li>
						</ul>
					</div>
				</div>
			</section>

			<section className='section novi-background section-md text-center'>
				<div className='container'>
					<h3 className='text-uppercase font-weight-bold wow-outer'>
						<span className='wow slideInDown green_text'>
							BUY CHOICE SERVICE PLOTS &amp; RESIDENCES IN LAGOS AND ACROSS
							NIGERIA WITHOUT STRESS
						</span>
					</h3>
					<p>
						Everyday in Lagos and other major cities across Nigeria, smart
						people are trusting experience real estate companies like us for the
						best residences and serviced plots. If you are looking to make wise
						real estate investment, we invite you to check out our carefully
						packaged property deals.
					</p>
				</div>
			</section>

			<section className='section novi-background section-md text-center'>
				<div className='container'>
					<h3 className='text-uppercase font-weight-bold wow-outer'>
						<span className='wow slideInDown green_text'>
							WHAT EXACTLY ARE YOU LOOKING FOR?
						</span>
					</h3>
					<div className='row row-lg-50 row-35 offset-top-2'>
						<div className='col-md-6 wow-outer'>
							<article className='post-modern wow slideInLeft'>
								<Link className='post-modern-media' to={`/properties/lands`}>
									<img src={estate2} alt='' width='571' height='353' />
								</Link>
								<h4 className='post-modern-title'>
									<Link className='post-modern-title' to={`/properties/lands`}>
										Check Out Our Available Lands.
									</Link>
								</h4>
							</article>
						</div>
						<div className='col-md-6 wow-outer'>
							<article className='post-modern wow slideInLeft'>
								<Link className='post-modern-media' to={`/properties/houses`}>
									<img src={estate2} alt='' width='571' height='353' />
								</Link>
								<h4 className='post-modern-title'>
									<Link className='post-modern-title' to={`/properties/houses`}>
										Check Out Our Available Houses.
									</Link>
								</h4>
							</article>
						</div>
					</div>
				</div>
			</section>
		</main>
	)
}

export default Properties
